import { type ReactNode } from "react";

type PillVariant = "solidDark" | "outlineLight";

export function Pill({
  children,
  variant = "solidDark",
  className = "",
}: { children: ReactNode; variant?: PillVariant; className?: string }) {
  const base = "inline-flex items-center font-semibold uppercase whitespace-nowrap";
  const styles =
    variant === "solidDark"
      // small, black, slightly rounded (not fully pill)
      ? "text-[10px] tracking-wide px-2 py-[2px] bg-black text-white rounded-md"
      // white chip with gray border, fully rounded, tiny text
      : "text-[11px] tracking-wide px-2 py-[2px] bg-white text-gray-900 border border-gray-300 rounded-full";
  return <span className={`${base} ${styles} ${className}`}>{children}</span>;
}